import apiClient from "@/services/apiClient";

export default {
    data() {
        return {
            ordersApiUrl: process.env.VUE_APP_ORDERS_API_URL,
            inventoryApiUrl: process.env.VUE_APP_INVENTORY_API_URL
        }
    },
    methods: {
        async fetchOrderStats(from, to) {
            if (!to) {
                to = from;
            }

            const {data} = await apiClient.get(`${this.ordersApiUrl}/stats/${from}/${to}`);

            return data;
        },
        async fetchInventoryStats(from, to) {
            if (!to) {
                to = from;
            }

            const {data} = await apiClient.get(`${this.inventoryApiUrl}/stats/${from}/${to}`);

            return data;
        },
        async fetchTotalInventoryCounts() {
            const {data} = await apiClient.get(`${this.inventoryApiUrl}/stats/totalInventoryCounts`);
            return data;
        },
        async refreshTotalInventoryCounts() {
            const { data } = await apiClient.get(`${this.inventoryApiUrl}/stats/refreshTotalInventoryCounts`);
            return data;
        },
        async fetchBadItems() {
            const {data} = await apiClient.get(`${this.inventoryApiUrl}/stats/badItems`);
            return data;
        },

        async refreshAllBadItems() {
            const { data } = await apiClient.get(`${this.inventoryApiUrl}/stats/refreshBadItems`);
            return data;
        }
    }
};